module.exports = __webpack_public_path__ + "static/media/gifts-postage-stationery.113af241.svg";